import { supabase } from '../../providers/supabase/client'

export interface Aeroline {
    id?: number,
    name: string,
    logo_url?: string | null,
    banner_logo_url?: string | null,
    checkin_hours_before?: number | null,
    checkin_url?: string | null,
    created_at?: string,
}

export const fetchAerolines = async () => {
    return await supabase
        .from('aerolines')
        .select('id, created_at, name, logo_url, banner_logo_url, checkin_hours_before, checkin_url')
        .order('name')
}

export const createAeroline = async (aeroline: Aeroline) => {
    return await supabase
        .from('aerolines')
        .insert([
            aeroline,
        ])
        .select()
}

export const addManyAerolines = async (aerolines: Aeroline[]) => {
    return await supabase
        .from('aerolines')
        .insert(aerolines)
        .select()
}

export const updateAeroline = async (id: number, aeroline: Partial<Aeroline>) => {
    return await supabase
        .from('aerolines')
        .update(aeroline)
        .eq('id', id)
        .select()
}

export const deleteAeroline = async (id: number) => {
    return await supabase
        .from('aerolines')
        .delete()
        .eq('id', id)
}

export const uploadAirlineLogo = async (airlineId: number, file: File, type: 'logo' | 'banner' = 'logo'): Promise<string | null> => {
    const fileExt = file.name.split('.').pop() || 'png';
    const path = `airlines/${airlineId}/${type}-${Date.now()}.${fileExt}`;

    const { error } = await supabase.storage
        .from('provider-logos')
        .upload(path, file, {
            upsert: true,
            contentType: file.type,
            cacheControl: '3600',
        });

    if (error) {
        console.error('Error uploading airline logo:', error);
        return null;
    }

    const { data: urlData } = supabase.storage
        .from('provider-logos')
        .getPublicUrl(path);

    return urlData?.publicUrl || null;
}



